<template>
  <div class="disabled" @click="showModal">
    <span class="menu-item-name">{{ $t("ui.menu." + item.name) }}</span>
    <i class="icon yule-icon-lock"></i>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object
      }
    },
    computed: {
    },
    methods: {
      showModal() {
        this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', true)
      }
    }
  }
</script>
<style lang="scss" scoped>
.disabled {
  pointer-events: auto;
  color: #525556;
  cursor: pointer;
  user-select: none;
  z-index: 10;
}
.yule-icon-lock {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// NavigationLockedItem.vue?645b09b2